module.exports = __webpack_public_path__ + "static/media/bn.80c35c4c.svg";